import { Union, Record } from "../fable_modules/fable-library.3.6.2/Types.js";
import { union_type, lambda_type, record_type, tuple_type, int32_type } from "../fable_modules/fable-library.3.6.2/Reflection.js";
import { Connection__isValid, MazeElement, map, permute, carve, normalize, hunterKiller, aldousBroder, doAlgorithm, newMaze, Maze$reflection } from "../Domain.fs.js";
import { Maze_render, Maze_MouseMode, Maze_MouseMode$reflection } from "./Components.fs.js";
import { equalArrays, comparePrimitives, max } from "../fable_modules/fable-library.3.6.2/Util.js";
import { createElement } from "react";
import { Interop_reactApi } from "../fable_modules/Feliz.1.57.0/Interop.fs.js";
import { ofArray } from "../fable_modules/fable-library.3.6.2/List.js";
import { ProgramModule_mkSimple, ProgramModule_run } from "../fable_modules/Fable.Elmish.3.1.0/program.fs.js";
import { Program_withReactSynchronous } from "../fable_modules/Fable.Elmish.React.3.0.1/react.fs.js";
import "./styles/global.scss";


export class State extends Record {
    constructor(size, maze, mode) {
        super();
        this.size = size;
        this.maze = maze;
        this.mode = mode;
    }
}

export function State$reflection() {
    return record_type("UI.Main.State", [], State, () => [["size", tuple_type(int32_type, int32_type)], ["maze", Maze$reflection()], ["mode", Maze_MouseMode$reflection()]]);
}

export class Msg extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Smaller", "Bigger", "Fresh", "AldousBroder", "HunterKiller", "RandomCarve", "RandomPermute", "SkipToEnd", "Transform"];
    }
}

export function Msg$reflection() {
    return union_type("UI.Main.Msg", [], Msg, () => [[], [], [], [], [], [], [], [], [["Item", lambda_type(State$reflection(), State$reflection())]]]);
}

export function fresh(size_0, size_1) {
    const size_2 = [size_0, size_1];
    return new State(size_2, newMaze(size_2[0], size_2[1], false), new Maze_MouseMode(2));
}

export function init(_arg1) {
    return fresh(20, 12);
}

export function update(msg, state) {
    switch (msg.tag) {
        case 0: {
            const patternInput = state.size;
            return fresh(max((x_1, y_1) => comparePrimitives(x_1, y_1), 1, patternInput[0] - 1), max((x_2, y_2) => comparePrimitives(x_2, y_2), 1, patternInput[1] - 1));
        }
        case 1: {
            const patternInput_1 = state.size;
            return fresh(patternInput_1[0] + 1, patternInput_1[1] + 1);
        }
        case 2: {
            const tupledArg = state.size;
            return fresh(tupledArg[0], tupledArg[1]);
        }
        case 3: {
            let state_1;
            const tupledArg_1 = state.size;
            state_1 = fresh(tupledArg_1[0], tupledArg_1[1]);
            return new State(state_1.size, doAlgorithm((unvisited) => aldousBroder(unvisited), state_1.maze), state_1.mode);
        }
        case 4: {
            let state_2;
            const tupledArg_2 = state.size;
            state_2 = fresh(tupledArg_2[0], tupledArg_2[1]);
            return new State(state_2.size, doAlgorithm((unvisited_1) => hunterKiller(unvisited_1), state_2.maze), state_2.mode);
        }
        case 5: {
            return new State(state.size, normalize(carve(30, state.maze)), state.mode);
        }
        case 6: {
            return new State(state.size, normalize(permute(20, state.maze)), state.mode);
        }
        case 8: {
            return msg.fields[0](state);
        }
        default: {
            return state;
        }
    }
}

export function view(state, dispatch) {
    const children = ofArray([createElement("div", {
        children: Interop_reactApi.Children.toArray(["Click to carve out spaces between cells. Right-click to add walls."]),
        style: {
            marginBottom: 10,
        },
    }), Maze_render(state.maze, state.mode, (tupledArg) => {
        let y$0027_2, x$0027_2, y$0027, x$0027;
        const mode$0027 = tupledArg[0];
        const matchValue = [mode$0027, tupledArg[1]];
        let pattern_matching_result, c_1, x$0027_1, y$0027_1;
        if (matchValue[0].tag === 0) {
            if (matchValue[1] != null) {
                if ((y$0027 = (matchValue[1].fields[1] | 0), (x$0027 = (matchValue[1].fields[0] | 0), Connection__isValid(matchValue[1])))) {
                    pattern_matching_result = 0;
                    c_1 = matchValue[1];
                    x$0027_1 = matchValue[1].fields[0];
                    y$0027_1 = matchValue[1].fields[1];
                }
                else {
                    pattern_matching_result = 1;
                }
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else {
            pattern_matching_result = 1;
        }
        switch (pattern_matching_result) {
            case 0: {
                dispatch(new Msg(8, (state_1) => (new State(state_1.size, normalize(map((x, y, state_2) => {
                    if (equalArrays([x, y], [x$0027_1, y$0027_1])) {
                        return new MazeElement(0);
                    }
                    else {
                        return state_2;
                    }
                }, state_1.maze)), mode$0027))));
                break;
            }
            case 1: {
                let pattern_matching_result_1, c_3, x$0027_3, y$0027_3;
                if (matchValue[0].tag === 1) {
                    if (matchValue[1] != null) {
                        if ((y$0027_2 = (matchValue[1].fields[1] | 0), (x$0027_2 = (matchValue[1].fields[0] | 0), Connection__isValid(matchValue[1])))) {
                            pattern_matching_result_1 = 0;
                            c_3 = matchValue[1];
                            x$0027_3 = matchValue[1].fields[0];
                            y$0027_3 = matchValue[1].fields[1];
                        }
                        else {
                            pattern_matching_result_1 = 1;
                        }
                    }
                    else {
                        pattern_matching_result_1 = 1;
                    }
                }
                else {
                    pattern_matching_result_1 = 1;
                }
                switch (pattern_matching_result_1) {
                    case 0: {
                        const m$0027 = normalize(map((x_1, y_1, state_3) => {
                            if (equalArrays([x_1, y_1], [x$0027_3, y$0027_3])) {
                                return new MazeElement(1);
                            }
                            else {
                                return state_3;
                            }
                        }, state.maze));
                        dispatch(new Msg(8, (state_4) => (new State(state_4.size, normalize(map((x_2, y_2, state_5) => {
                            if (equalArrays([x_2, y_2], [x$0027_3, y$0027_3])) {
                                return new MazeElement(1);
                            }
                            else {
                                return state_5;
                            }
                        }, state_4.maze)), mode$0027))));
                        break;
                    }
                    case 1: {
                        if (matchValue[0].tag === 2) {
                            dispatch(new Msg(8, (state_6) => (new State(state_6.size, state_6.maze, new Maze_MouseMode(2)))));
                        }
                        else {
                            dispatch(new Msg(8, (state_7) => (new State(state_7.size, state_7.maze, mode$0027))));
                        }
                        break;
                    }
                }
                break;
            }
        }
    }), createElement("button", {
        children: "Reset",
        onClick: (_arg1) => {
            dispatch(new Msg(2));
        },
    }), createElement("button", {
        children: "Aldous-Broder",
        onClick: (_arg2) => {
            dispatch(new Msg(3));
        },
    }), createElement("button", {
        children: "Hunt and Kill",
        onClick: (_arg3) => {
            dispatch(new Msg(4));
        },
    }), createElement("button", {
        children: "Carve",
        onClick: (_arg4) => {
            dispatch(new Msg(5));
        },
    }), createElement("button", {
        children: "Permute",
        onClick: (_arg5) => {
            dispatch(new Msg(6));
        },
    }), createElement("button", {
        children: "Smaller",
        onClick: (_arg6) => {
            dispatch(new Msg(0));
        },
    }), createElement("button", {
        children: "Bigger",
        onClick: (_arg7) => {
            dispatch(new Msg(1));
        },
    })]);
    return createElement("div", {
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    });
}

ProgramModule_run(Program_withReactSynchronous("feliz-app", ProgramModule_mkSimple(init, (msg, state) => update(msg, state), (state_1, dispatch) => view(state_1, dispatch))));

